import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import styled from "styled-components";
import { ButtonPrimary } from "../../components/buttonStyles/style";
import { Input, SelectInput } from "../../components/Inputs";
import LazyLoading from "../../components/lazyLoading";
import {
  H5,
  H6,
  LoadingIcon,
  TextBold,
} from "../../components/textStyles/style";
import { usersRolesOptions } from "../../data/SelectOptions";
let Height = "calc(100vh - clamp(54px, 8vw, 84px) - 62px)";

const Wrapper = styled.div`
  width: 100vw;
  min-height: ${Height};
  display: flex;
  justify-content: center;
`;
const ContentWrapper = styled.div`
  background-color: white;
  width: 90%;
  padding: 30px;
  border-radius: 20px;
  margin: 30px 0;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-top: 20px;
`;

const LoadingWrapper = styled.div`
  width: 100vw;
  min-height: ${Height};
  display: flex;
  justify-content: center;
`;

const User = () => {
  const { user_id } = useParams();
  const history = useHistory();
  const [loader, setLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [experts, setExperts] = useState([]);
  const [role, setRole] = useState("");
  const [expert, setExpert] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [username, setUsername] = useState("");

  const submitHandler = async () => {
    if (!loading) {
      setLoading(true);
      setErrorMessage("");
      const TOKEN = localStorage.getItem("TOKEN");
      try {
        const data = {
          access_token: TOKEN,
          username,
          role,
          firstname,
          lastname,
          expert: role === "expert" ? expert : "",
        };

        await axios.put(
          `${process.env.REACT_APP_DASHBOARD_USER}?user_id=${user_id}`,
          data
        );
        setLoading(false);
        history.goBack();
      } catch (error) {
        setLoading(false);
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        console.log(error);
        setErrorMessage("Probléme de Connexion");
      }
    }
  };

  const getUserAndExpertsData = async () => {
    setLoader(true);
    const TOKEN = localStorage.getItem("TOKEN");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TOKEN}`,
      },
    };
    // get experts list
    const ex = await axios.get(
      `${process.env.REACT_APP_GET_EXPERTS_DROPDOWN}?category=1`,
      config
    );

    const repsonse = await axios.get(
      `${process.env.REACT_APP_DASHBOARD_USER}?user_id=${user_id}`,
      config
    );
    const u = repsonse.data;

    setFirstname(u.firstname);
    setLastname(u.lastname);
    setRole(u.role);
    setUsername(u.username);

    const currentExpert = ex.data.find((element) => element.value === u.expert);

    setExpert(currentExpert ? currentExpert.value : "");
    setExperts(ex.data);

    setLoader(false);
  };

  useEffect(() => {
    getUserAndExpertsData();
  }, []);

  if (loader) {
    return (
      <LoadingWrapper>
        <LazyLoading height={Height} />
      </LoadingWrapper>
    );
  }

  return (
    <Wrapper>
      <ContentWrapper>
        <H5>Update User</H5>
        <Row>
          <TextBold color="#c22222">
            {errorMessage ? errorMessage : " "}
          </TextBold>
        </Row>
        <H6>General Informations</H6>

        {/** firstname - lastname */}
        <Row style={{ marginBottom: 25 }}>
          <Input
            placeholder="Firstname *"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
          />
          <Input
            placeholder="Lastname *"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
          />
        </Row>
        <H6>Account Informations</H6>
        <Row>
          <Input
            placeholder="Email *"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Row>
        <Row>
          <SelectInput
            values={usersRolesOptions}
            placeholder="Role *"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          />
          {role === "expert" && (
            <SelectInput
              values={experts}
              placeholder="Expert *"
              value={expert}
              onChange={(e) => setExpert(e.target.value)}
            />
          )}
        </Row>
        <Row style={{ marginTop: 40 }}>
          <ButtonPrimary onClick={submitHandler}>
            {loading ? <LoadingIcon color="inherit" /> : "Update user"}
          </ButtonPrimary>
        </Row>
      </ContentWrapper>
    </Wrapper>
  );
};

export default User;
